import { h } from "preact";
import { AppPage } from '../../_common/components/app-page'
import { ButtonGhost } from '../../_common/components/buttons/buttons'
import { Form as FinalForm } from 'react-final-form'
import { C, Card, F } from "../../_common/layout";
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router'
import { useEffect, useState } from 'preact/hooks'
import { confirmCompanyForm, fetchCompanyForm, fetchStatus, postCompanyForm } from "../../_rx/fct/actions";
import { validationDocumentFCT } from '../components/UploadDocument/validationDocumentFCT'
import { Link } from 'react-router-dom'
import ButtonSpinner from '../../_common/components/buttons/buttonSpinner/buttonSpinner'
import { t } from '../../_i18n'
import { FormField, FormFieldSelect } from "../../_common/forms/components/components";
import "./ContributedCompany.scss"
import { isMobileAgent } from "../../_common/common";
import { toastService } from "../../_services/toast-service";

export default function ContributeCompany () {
  const { id } = useParams()
  const [loadingDraft, setLoadingDraft] = useState(false)
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false)
  const history = useHistory()
  const [data, setData] = useState(null)
  const isMobile = isMobileAgent();

  const companyTypeOptions = [
    { key: 'ind', name: t('Empresario individual') },
    { key: 'micro', name: t('Micro Empresa') },
    { key: 'peq', name: t('Pequeña Empresa') },
    { key: 'med', name: t('Mediana Empresa') },
    { key: 'gran', name: t('Gran Empresa') },
    { key: 'fund', name: t('Asociación o Fundación') },
    { key: 'pub', name: t('Organismo Público') }
  ];

  useEffect(() => {
    fetchCompanyForm(id).then(response => {
      setData(response)
    })
  }, [id])

  const saveCompanyDraft = (values) => {
    setLoadingDraft(true)
    return postCompanyForm(id, values).finally(() => setLoadingDraft(false))
  }

  const submitForm = async (values) => {
    if (isLoadingSubmit) return
    const hasSchedule =
      values.monday?.trim() ||
      values.tuesday?.trim() ||
      values.wednesday?.trim() ||
      values.thursday?.trim() ||
      values.friday?.trim();

    if (!hasSchedule) {
      toastService.showToast({
        message: t("Debes rellenar al menos un campo del horario"),
        type: "danger"
      });
      return;
    }

    setIsLoadingSubmit(true)
    try {
      await confirmCompanyForm(id);
      toastService.showToast({ message: t("Solicitud de revisión enviada correctamente"), type: 'info' });
      history.push(`/fct/${id}`)
    } catch (error) {
     toastService.showToast({ message: t(error.body.message || "Error al enviar la solicitud"), type: 'danger' });
    } finally {
      setIsLoadingSubmit(false)
    }
  }

  const scroll = () => {
    setTimeout(() => {
      const el = document.querySelector('.error');
      el && el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    })
  }

  if (!data) return <div />
  return (
    <AppPage title={t('Aportar empresa')} back={history.goBack} className="max-width-980">
      <F className="max-width-980">
        <C>
          <Card smOnly={true} class="p-top p-bottom">
            <FinalForm
              onSubmit={submitForm}
              initialValues={data}
              render= {({ handleSubmit, values, submitFailed, hasValidationErrors, ...props }) => {
                return (
                  <form action="" onSubmit={handleSubmit} noValidate>
                    {submitFailed && !props.dirtySinceLastSubmit && scroll()}
                    <h1 class="title">{t('DATOS DE LA EMPRESA')}</h1>
                    <div className='m-top'>
                      <div class="container-form-3-el">
                        <FormField
                          name='name'
                          label={t('Nombre')}
                          specificError={t('Por favor, escribe el nombre.')}
                          required
                          onBlur={() => saveCompanyDraft(values)}
                          validate={validationDocumentFCT}
                        />
                        <FormField
                          name='tax_id'
                          label={t('Identificador Fiscal')}
                          specificError={t('Por favor, escribe el identificador fiscal.')}
                          required
                          onBlur={() => saveCompanyDraft(values)}
                          validate={validationDocumentFCT}
                        />
                        <FormFieldSelect
                          name='company_type'
                          label={t('Tipología de la empresa')}
                          options={companyTypeOptions}
                          required
                          specificError={t('Por favor, indica en la tipología de la empresa.')}
                          onChange={() => saveCompanyDraft(values)}
                          validate={validationDocumentFCT}
                        />
                      </div>
                      <hr className="separator-xxs"/>
                      <h2 class="m-top-x2 f-w-700">{t('DATOS UBICACIÓN')}</h2>
                      <div class="container-form m-top">
                        <FormField
                          name='address.country'
                          label={t('País')}
                          specificError={t('Por favor, escribe el país.')}
                          required
                          onBlur={() => saveCompanyDraft(values)}
                          validate={validationDocumentFCT}
                        />
                        <FormField
                          name='address.region'
                          label={t('Región')}
                          specificError={t('Por favor, escribe la región.')}
                          required
                          onBlur={() => saveCompanyDraft(values)}
                          validate={validationDocumentFCT}
                        />
                      </div>
                      <div class="container-form m-top">
                        <FormField
                          name='address.postal_code'
                          label={t('Código Postal')}
                          specificError={t('Por favor, escribe el código postal.')}
                          required
                          onBlur={() => saveCompanyDraft(values)}
                          validate={validationDocumentFCT}
                        />
                        <FormField
                          name='address.city'
                          label={t('Municipio/Localidad')}
                          specificError={t('Por favor, escribe la ciudad.')}
                          required
                          onBlur={() => saveCompanyDraft(values)}
                          validate={validationDocumentFCT}
                        />
                      </div>
                      <div class="container-form m-top">
                        <FormField
                          name='address.street_type'
                          label={t('Via')}
                          specificError={t('Por favor, escribe la via.')}
                          required
                          onBlur={() => saveCompanyDraft(values)}
                          validate={validationDocumentFCT}
                        />
                        <FormField
                          name='address.address'
                          label={t('Dirección')}
                          specificError={t('Por favor, escribe la dirección.')}
                          required
                          onBlur={() => saveCompanyDraft(values)}
                          validate={validationDocumentFCT}
                        />
                      </div>
                      <div class="container-form m-top">
                        <FormField
                          name="address.street_number"
                          label={t("Número")}
                          type="number"
                          onBlur={() => saveCompanyDraft(values)}
                        />
                        <FormField
                          name='address.floor_door'
                          label={t('Escalera/Piso/Puerta')}
                          onBlur={() => saveCompanyDraft(values)}
                        />
                      </div>
                      <div class="container-form m-top">
                        <FormField
                          name='address.extra_address'
                          label={t('Resto de la dirección')}
                          onBlur={() => saveCompanyDraft(values)}
                        />
                        <FormField
                          name='address.polygon'
                          label={t('Polígono')}
                          onBlur={() => saveCompanyDraft(values)}
                        />
                      </div>
                      <div class="container-form m-top">
                        <FormField
                          name='phone'
                          label={t('Teléfono')}
                          specificError={t('Por favor, escribe el teléfono.')}
                          required
                          type='number'
                          onBlur={() => saveCompanyDraft(values)}
                          validate={validationDocumentFCT}
                        />
                        <FormField
                          name='fax'
                          label={t('Fax')}
                          onBlur={() => saveCompanyDraft(values)}
                        />
                      </div>
                      <hr className="separator-xxs"/>
                      <h1 class="title m-top-x2">{t('DATOS DEL CENTRO DONDE EL ALUMNO REALIZARÁ LAS PRÁCTICAS')}</h1>
                      <div class="container-form-3-el m-top">
                        <FormField
                          name='center.center_type'
                          label={t('Tipología del centro de trabajo')}
                          specificError={t('Por favor, escribe la tipología del centro de trabajo.')}
                          required
                          onBlur={() => saveCompanyDraft(values)}
                          validate={validationDocumentFCT}
                        />
                        <FormField
                          name='center.name'
                          label={t('Nombre')}
                          specificError={t('Por favor, escribe el nombre.')}
                          required
                          onBlur={() => saveCompanyDraft(values)}
                          validate={validationDocumentFCT}
                        />
                        <FormField
                          name='center.optional_name'
                          label={t('Nombre')}
                          onBlur={() => saveCompanyDraft(values)}
                        />
                      </div>
                      <hr className="separator-xxs"/>
                      <h2 class="m-top-x2 f-w-700">{t('DATOS UBICACIÓN')}</h2>
                      <div class="container-form m-top">
                        <FormField
                          name='center.address.country'
                          label={t('País')}
                          specificError={t('Por favor, escribe el país.')}
                          required
                          onBlur={() => saveCompanyDraft(values)}
                          validate={validationDocumentFCT}
                        />
                        <FormField
                          name='center.address.region'
                          label={t('Región')}
                          specificError={t('Por favor, escribe la región.')}
                          required
                          onBlur={() => saveCompanyDraft(values)}
                          validate={validationDocumentFCT}
                        />
                      </div>
                      <div class="container-form m-top">
                        <FormField
                          name='center.address.postal_code'
                          label={t('Código Postal')}
                          specificError={t('Por favor, escribe el código postal.')}
                          required
                          onBlur={() => saveCompanyDraft(values)}
                          validate={validationDocumentFCT}
                        />
                        <FormField
                          name='center.address.city'
                          label={t('Municipio/Localidad')}
                          specificError={t('Por favor, escribe la ciudad.')}
                          required
                          onBlur={() => saveCompanyDraft(values)}
                          validate={validationDocumentFCT}
                        />
                      </div>
                      <div class="container-form m-top">
                        <FormField
                          name='center.address.street_type'
                          label={t('Via')}
                          specificError={t('Por favor, escribe la via.')}
                          required
                          onBlur={() => saveCompanyDraft(values)}
                          validate={validationDocumentFCT}
                        />
                        <FormField
                          name='center.address.address'
                          label={t('Dirección')}
                          specificError={t('Por favor, escribe la dirección.')}
                          required
                          onBlur={() => saveCompanyDraft(values)}
                          validate={validationDocumentFCT}
                        />
                      </div>
                      <div class="container-form m-top">
                        <FormField
                          name='center.address.street_number'
                          label={t('Número')}
                          type='number'
                          onBlur={() => saveCompanyDraft(values)}
                        />
                        <FormField
                          name='center.address.floor_door'
                          label={t('Escalera/Piso/Puerta')}
                          onBlur={() => saveCompanyDraft(values)}
                        />
                      </div>
                      <div class="container-form m-top">
                        <FormField
                          name='center.address.extra_address'
                          label={t('Resto de la dirección')}
                          onBlur={() => saveCompanyDraft(values)}
                        />
                        <FormField
                          name='center.address.polygon'
                          label={t('Polígono')}
                          onBlur={() => saveCompanyDraft(values)}
                        />
                      </div>
                      <hr className="separator-xxs"/>
                      <h2 class="m-top-x2 f-w-700">{t('DATOS CONTACTO')}</h2>
                      <div class="container-form-3-el m-top">
                        <FormField
                          name='center.contact.phone'
                          label={t('Teléfono')}
                          specificError={t('Por favor, escribe el teléfono.')}
                          required
                          type='number'
                          onBlur={() => saveCompanyDraft(values)}
                          validate={validationDocumentFCT}
                        />
                        <FormField
                          name='center.contact.fax'
                          label={t('Fax')}
                          onBlur={() => saveCompanyDraft(values)}
                        />
                        <FormField
                          name='center.contact.email'
                          label={t('Correo electrónico')}
                          onBlur={() => saveCompanyDraft(values)}
                        />
                      </div>
                      <hr className="separator-xxs"/>
                      <h2 class="m-top-x2 f-w-700">{t('DATOS RESPONSABLE')}</h2>
                      <div class="container-form m-top">
                        <FormField
                          name='center.responsible.dni'
                          label={t('DNI')}
                          specificError={t('Por favor, escribe el dni.')}
                          required
                          onBlur={() => saveCompanyDraft(values)}
                          validate={validationDocumentFCT}
                        />
                        <FormField
                          name='center.responsible.name'
                          label={t('Nombre')}
                          specificError={t('Por favor, escribe el nombre.')}
                          required
                          onBlur={() => saveCompanyDraft(values)}
                          validate={validationDocumentFCT}
                        />
                      </div>
                      <div class="container-form m-top">
                        <FormField
                          name='center.responsible.email'
                          label={t('Correo electrónico')}
                          onBlur={() => saveCompanyDraft(values)}
                        />
                        <FormField
                          name='center.responsible.phone'
                          specificError={t('Por favor, escribe el teléfono.')}
                          required
                          label={t('Teléfono')}
                          type='number'
                          onBlur={() => saveCompanyDraft(values)}
                          validate={validationDocumentFCT}
                        />
                      </div>
                      <div class="container-form m-top">
                        <FormField
                          name='center.responsible.position'
                          label={t('Cargo')}
                          onBlur={() => saveCompanyDraft(values)}
                        />
                        <FormField
                          name='center.responsible.fax'
                          label={t('Fax')}
                          onBlur={() => saveCompanyDraft(values)}
                        />
                      </div>

                      <hr className="separator-xxs"/>
                      <h2 class="m-top-x2 f-w-700">{t('DATOS TUTOR')}</h2>
                      <div class="container-form m-top">
                        <FormField
                          name='center.tutor.dni'
                          label={t('DNI')}
                          specificError={t('Por favor, escribe el dni.')}
                          required
                          onBlur={() => saveCompanyDraft(values)}
                          validate={validationDocumentFCT}
                        />
                        <FormField
                          name='center.tutor.name'
                          label={t('Nombre')}
                          specificError={t('Por favor, escribe el nombre.')}
                          required
                          onBlur={() => saveCompanyDraft(values)}
                          validate={validationDocumentFCT}
                        />
                      </div>
                      <div class="container-form m-top">
                        <FormField
                          name='center.tutor.email'
                          label={t('Correo electrónico')}
                          onBlur={() => saveCompanyDraft(values)}
                        />
                        <FormField
                          name='center.tutor.phone'
                          label={t('Teléfono')}
                          specificError={t('Por favor, escribe el teléfono.')}
                          required
                          type='number'
                          onBlur={() => saveCompanyDraft(values)}
                          validate={validationDocumentFCT}
                        />
                      </div>

                      <hr className="separator-xxs"/>
                      <h2 class="m-top-x2 f-w-700">{t('HORARIO')}</h2>
                      <div class="container-form-3-el m-top">
                        <FormField
                          name='monday'
                          label={t('Lunes')}
                          onBlur={() => saveCompanyDraft(values)}
                        />
                        <FormField
                          name='tuesday'
                          label={t('Martes')}
                          onBlur={() => saveCompanyDraft(values)}
                        />
                        <FormField
                          name='wednesday'
                          label={t('Miércoles')}
                          onBlur={() => saveCompanyDraft(values)}
                        />
                      </div>
                      <div class="container-form m-top">
                        <FormField
                          name='thursday'
                          label={t('Jueves')}
                          onBlur={() => saveCompanyDraft(values)}
                        />
                        <FormField
                          name='friday'
                          label={t('Viernes')}
                          onBlur={() => saveCompanyDraft(values)}
                        />
                      </div>
                      <div className='m-top-x2'><hr className="separator-xxs"/></div>
                      <div className='ftp-button-bar'>
                        <ButtonSpinner classNameContainer={`${isMobile ? 'full-width' : ''}`}
                          type='submit'
                          showSpinner={isLoadingSubmit}
                        >
                          {t('Enviar solicitud')}
                        </ButtonSpinner>
                        <Link to={`/fct/${id}`}><ButtonGhost type='button'>{t('Cancelar')}</ButtonGhost></Link>
                      </div>
                    </div>
                  </form>
                )
              }}/>
          </Card>
        </C>
      </F>
    </AppPage>
  )
}
